/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedSearchSuggestions_itemSearch$ref = any;
export type SbSharedSearchSuggestions_itemSearch = {
    readonly pageType: string | null;
    readonly searchCorrections: {
        readonly suggestions: ReadonlyArray<{
            readonly name: string | null;
            readonly uri: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": SbSharedSearchSuggestions_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedSearchSuggestions_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "searchCorrections",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "suggestions",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchCorrectionSuggestionsValues",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "uri",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'f8fd0aeee9c1231e9ec4431fcc26fec8';
export default node;
